<template>
  <b-row class="overflow-y py-2">
    <b-col md="6" lg="3" cols="6" v-for="i in items" :key="i">
      <div class="btn-group btn-group-toggle btn-block mb-4">
        <label
          class="btn btn-sm btn-outline-primary"
          :class="{active: input.item.value == i}"
        >
          <input
            type="radio"
            v-model="input.item.value"
            :value="i"
          >
          <div :class="css_quality_assoc[quality[i]]" class="quality rounded"></div>
          <b-img-lazy
            :src="findThumb(i)"
            fluid-grow
            rounded
          ></b-img-lazy>
          <span>{{ i }}</span>
        </label>
      </div>
    </b-col>
  </b-row>
</template>

<script>
var thumbs = require('../thumbs.json');

var css_quality_assoc = {
  'Common': 'common',
  'Premium': 'premium',
  'Rare': 'rare',
  'Very Rare': 'very-rare',
  'Import': 'import',
  'Exotic': 'exotic',
  'Black Market': 'black-market',
  'Limited': 'limited'
}

export default {
  name: 'Items',
  data() {
    return {
      thumbs: thumbs,
      css_quality_assoc: css_quality_assoc
    }
  },
  props: {
    items: Array,
    quality: Object,
    item_slot: String,
    input: Object // user input
  },
  methods: {
    findThumb: function(item_name) {
      var slot = this.item_slot;
      if (this.thumbs[slot][item_name]) {
        return `${process.env.BASE_URL}img/thumbs/items/${this.thumbs[slot][item_name]}.jpg`;
      } if (item_name == 'None') {
          return require('@/assets/img/thumbs/none.png')
      } else {
          return require('@/assets/img/thumbs/nothumb.png')
      }
    }
  }
}
</script>

<style scoped>
#tabs .overflow-y {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  height: 19.7em;
}

#tabs .overflow-y .btn {
  padding: 0;
  border-width: 0;
  border-width: 5px;
  border-color: transparent;
  text-shadow: 0px 0px 4px black, 0px 0px 4px black, 0px 0px 4px black, 0px 0px 4px black;
}

#tabs .overflow-y .btn:hover {
  border-width: 5px;
}

#tabs .overflow-y .btn span {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: white;
  margin: 0.25em;
  line-height: 1.25em;
}

#tabs .overflow-y .btn img {
  background-color: black;
}

#tabs .btn-group .active {
  border-width: 5px;
}

.quality {
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
}

.btn span {
  z-index: 2;
}

.limited {
  background: linear-gradient(to bottom,transparent 0,rgba(247,121,57,.4) 80%);
}

.uncommon {
  background: linear-gradient(to bottom,transparent 0,rgba(125,217,253,.4) 80%);
}

.premium {
  background: linear-gradient(to bottom,transparent 0,rgba(107,241,174,.4) 80%);
}

.rare {
  background: linear-gradient(to bottom,transparent 0,rgba(116,151,235,.4) 80%);
}

.very-rare {
  background: linear-gradient(to bottom,transparent 0,rgba(158,124,252,.4) 80%);
}

.import {
  background: linear-gradient(to bottom,transparent 0,rgba(227,90,82,.4) 80%);
}

.exotic {
  background: linear-gradient(to bottom,transparent 0,rgba(236,219,108,.4) 80%);
}

.black-market {
  background: linear-gradient(to bottom,transparent 0,rgba(255,0,255,.4) 80%);
}

@media (min-width: 768px) {
  #tabs .overflow-y {
    height: 56.38em;
  }
}

</style>